// Kuch Hatke Media – theme JS
(function(){
  document.addEventListener('DOMContentLoaded', function(){
    // mobile nav toggle
    var toggle = document.querySelector('[data-nav-toggle]');
    var nav = document.querySelector('[data-nav]');
    if(toggle && nav){
      toggle.addEventListener('click', function(){
        var open = nav.classList.toggle('open');
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }

    // Product page variant selector – keeps price and add-to-cart id in sync
    var vpicker = document.querySelector('[data-variant-picker]');
    if(vpicker){
      var priceEl = document.querySelector('[data-variant-price]');
      var idInput = document.querySelector('[data-variant-id]');
      vpicker.addEventListener('change', function(e){
        if(e.target.matches('input[name="id"]')){
          var price = e.target.getAttribute('data-price');
          if(priceEl && price){ priceEl.textContent = price; }
          if(idInput){ idInput.value = e.target.value; }
        }
      });
    }
  });
})();
